<template>
  <div class="text-center py-1">
    <div v-for="bar in bars" :key="bar">
      <trial-expired v-if="bar === 'trial_ends'"/>
      <has-past-due-bar v-if="bar === 'has_past_due_subscription'"/>
      <has-pending-payment-bar v-if="bar === 'has_pending_payment'"/>
    </div>
  </div>
</template>

<script>
import TrialExpired from "./widgets/TrialExpired";
import HasPastDueBar from "./widgets/HasPastDueBar";
import HasPendingPaymentBar from "./widgets/HasPendingPaymentBar";

export default {
  name: "SubscriptionBar",
  components: {HasPendingPaymentBar, HasPastDueBar, TrialExpired},
  props: ['bars']
}
</script>

<style scoped>
</style>